
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/educenter",
      function () {
        return require("private-next-pages/case-study/educenter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/educenter"])
      });
    }
  